<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-title">{{ $t('message.home.shoppingCart') }}</div>
        <div v-loading="loading">
          <div v-if="cartItems.length" class="cart-wrap">
            <div class="cart-header">
              <el-checkbox v-model="allSelected" @change="handleSelectAll">{{ $t('message.home.selectAll') }}</el-checkbox>
              <span class="th-name">{{ $t('message.home.goodsName') }}</span>
              <span class="th-price">{{ $t('message.home.price') }}</span>
              <span class="th-qty">{{ $t('message.home.quantity') }}</span>
              <span class="th-subtotal">{{ $t('message.home.subtotal') }}</span>
              <span class="th-action">{{ $t('message.home.action') }}</span>
            </div>
            <div class="cart-item" v-for="item in cartItems" :key="item.id">
              <el-checkbox v-model="item.selected" @change="onItemSelect(item)" />
              <img :src="item.goodsThumbnail || item.thumbnail" class="item-img" />
              <div class="item-name">{{ item.goodsName || item.name }}</div>
              <div class="item-price">{{ priceFmt(item.price) }}</div>
              <div class="item-qty">
                <el-input-number v-model="item.quantity" :min="1" :max="99" size="small"
                  @change="(val) => handleQtyChange(item, val)" />
              </div>
              <div class="item-subtotal">{{ priceFmt(item.price * item.quantity) }}</div>
              <div class="item-action">
                <el-button type="text" @click="handleRemove(item)">{{ $t('message.home.delete') }}</el-button>
              </div>
            </div>
            <div class="cart-footer">
              <span class="selected-count">{{ $t('message.home.selected') }}：{{ selectedItems.length }} {{ $t('message.home.items') }}</span>
              <span class="total-label">{{ $t('message.home.total') }}：</span>
              <span class="total-amount">{{ priceFmt(totalAmount) }}</span>
              <el-button type="primary" size="medium" :disabled="!selectedItems.length" @click="goCheckout">
                {{ $t('message.home.checkout') }}
              </el-button>
            </div>
          </div>
          <el-empty v-if="!cartItems.length && !loading" :description="$t('message.home.emptyCart')" />
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { list, modify, remove, select } from '@/api/order/cart'
import { formatCurrency } from '@/util'

export default {
  name: 'CartPage',
  data() {
    return { loading: false, cartItems: [] }
  },
  computed: {
    allSelected: {
      get() { return this.cartItems.length > 0 && this.cartItems.every(i => i.selected) },
      set(val) { this.cartItems.forEach(i => { i.selected = val }) }
    },
    selectedItems() { return this.cartItems.filter(i => i.selected) },
    totalAmount() {
      return this.selectedItems.reduce((sum, i) => sum + i.price * i.quantity, 0).toFixed(2)
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      list().then(r => {
        const items = r.data?.cartItems || r.data?.data || []
        this.cartItems = items.map(i => ({ ...i, selected: !!i.isSelected }))
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleSelectAll(val) {
      this.cartItems.forEach(i => { i.selected = val })
      select({ all: val }).catch(() => {})
    },
    onItemSelect(item) {
      select({ cartItemId: item.id, selected: item.selected }).catch(() => {})
    },
    handleQtyChange(item, val) {
      modify({ cartItemId: item.id, quantity: val }).catch(() => {})
    },
    handleRemove(item) {
      remove({ cartItemIds: item.id }).then(() => {
        this.cartItems = this.cartItems.filter(i => i.id !== item.id)
      })
    },
    goCheckout() { this.$router.push('/settlement') },
    priceFmt(num) { return formatCurrency(num) }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-title { font-size: 22px; font-weight: bold; margin-bottom: 24px; }
.cart-wrap { background: #fff; border-radius: 8px; overflow: hidden; }
.cart-header { display: flex; align-items: center; padding: 14px 20px; background: #fafafa; border-bottom: 1px solid #eee; font-size: 14px; color: #606266; gap: 16px; }
.th-name { flex: 1; }
.th-price, .th-qty, .th-subtotal, .th-action { width: 120px; text-align: center; }
.cart-item { display: flex; align-items: center; padding: 16px 20px; border-bottom: 1px solid #f0f0f0; gap: 16px; }
.item-img { width: 80px; height: 80px; object-fit: cover; border-radius: 4px; flex-shrink: 0; }
.item-name { flex: 1; font-size: 14px; color: #303133; line-height: 1.5; }
.item-price, .item-subtotal { width: 120px; text-align: center; font-size: 15px; color: #e6a23c; }
.item-subtotal { color: #f56c6c; font-weight: bold; }
.item-qty { width: 120px; display: flex; justify-content: center; }
.item-action { width: 120px; text-align: center; }
.cart-footer { display: flex; align-items: center; justify-content: flex-end; padding: 20px; gap: 20px; }
.selected-count { color: #909399; font-size: 14px; }
.total-label { font-size: 15px; }
.total-amount { font-size: 22px; font-weight: bold; color: #f56c6c; }
</style>
